export class YearModel {

    public numeric: number;
    public label: string;
    public isLeapYear: boolean;

    constructor(year: number) {
        this.numeric = year
        this.label = year.toString();
        this.isLeapYear = year % 4 === 0;
    }
}